import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ButtonBuilder } from '../../GlobalComponents/Builders';
import { Card, CardBody } from 'reactstrap'
import { AccountContext } from '../../GlobalComponents/Authentication/Accounts';
import { Col } from 'react-bootstrap';
import OrderReport from '../Tools/Tool/components/subcomponents/OrderReport';
import ActivationReport from '../Tools/Tool/components/subcomponents/ActivationReport';
import RepCommissionReport from '../Tools/Tool/components/subcomponents/RepCommissionReport';
import OrderDashboard from '../Tools/Tool/components/subcomponents/OrderDashboard';
import CommissionDashboard from '../Tools/Tool/components/subcomponents/CommissionDashboard';

const OEPReports = () => {

    const { userSession } = useContext(AccountContext);

    const [expectedComission, setExpectedComission] = useState(false);
    const [orderReport, setOrderReport] = useState(<OrderReport/>);
    const [activationReport, setActivationReport] = useState(false);
    const [repCommisionReport, setRepCommisionReport] = useState(false);
    const [orderDashboard, setOrderDashboard] = useState(false);
    const [commissionDashboard, setcommissionDashboard] = useState(false);

    useEffect(() => {
        document.title = 'OEP Reports'
        checkUser()
    }, []);

    const checkUser = () => {
        if (userSession.email == 'ckolar@wirelesssupport.com' || userSession.email.includes('@nexnow.net'))
            setExpectedComission(true)
        else
            setExpectedComission(false)
    }

    const handleReport = (report) => {
        setActivationReport(false)
        setRepCommisionReport(false)
        setOrderDashboard(false)
        setOrderReport(false)
        setcommissionDashboard(false)
        
        if (report == 'order') setOrderReport(<OrderReport/>)
        else if (report == 'activation') setActivationReport(<ActivationReport/>)
        else if (report == 'repCommision') setRepCommisionReport(<RepCommissionReport/>)
        else if (report == 'orderDashboard') setOrderDashboard(<OrderDashboard/>)
        else if (report == 'commissionDashboard') setcommissionDashboard(<CommissionDashboard/>)
    }

    return (
        <Fragment>
            <Col xl="12">
                <Card>
                    <CardBody>
                        <h4>Order Entry Portal - Reports</h4>
                        <br/>
                        <ButtonBuilder label='Order Report' className='m-2' color='secondary' onClick={() => handleReport('order')} />
                        <ButtonBuilder label='Activation Report' className='m-2' color='secondary' onClick={() => handleReport('activation')} />
                        <ButtonBuilder label='Order Dashboard' className='m-2' color='secondary' onClick={() => handleReport('orderDashboard')} />
                        <ButtonBuilder label='Commission Dashboard' className='m-2' color='secondary' onClick={() => handleReport('commissionDashboard')} />
                        {expectedComission ? <ButtonBuilder label='Rep Commission Report' className='m-2' color='secondary' onClick={() => handleReport('repCommision')} /> : ''}
                        {orderReport}
                        {activationReport}
                        {repCommisionReport}
                        {orderDashboard}
                        {commissionDashboard}
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
};

export default OEPReports;
